import {
  INIT_GREETING_FOR_NEW_SETUP,
  SET_EXTERNAL_OVERLAY,
  SET_IDS,
  SET_INFO,
  SET_SAVE_ERROR,
  SET_SYSTEM_FEATURE_FLAGS,
  SET_TOKEN,
  SET_VOICES,
  UPDATE_DESTINATIONS,
  UPDATE_GREETING,
  UPDATE_GREETING_ERROR,
  UPDATE_CHANNEL_ID,
  UPDATE_CHANNEL_ID_ERROR,
  UPDATE_SETUP_STATUS,
  UPDATE_VOICE,
  RESET_CHANNEL_ID,
} from "../actions/InfoActions";

const initialState = {
  token: null,
  isValidToken: false,
  isNew: false,

  saveError: null,

  externalOverlay: false,

  destinations: [],

  organizationId: null,
  accountId: "",
  setupId: "",

  systemFeatureFlags: null,

  channelId: null,
  updatedChannelId: null,
  agentName: "",
  agentId: null,
  agentLanguage: "en-US",

  organization: {
    id: null,
    name: "",
    featureFlags: {},
    productName: "Smart Receptionist",
  },

  account: {
    id: null,
    name: "",
    featureFlags: {},
  },

  setup: {
    id: null,
    name: "",
  },

  voices: [],
  voice: "ethan",
  updatedVoice: "ethan",

  greetingError: "",
  channelIdError: null,
  greeting: "",
  updatedGreeting: "",

  isEnable: true,
};

const infoReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_INFO:
      return {
        ...state,
        organization: {
          ...state.organization,
          ...action.payload.organization,
        },
        account: {
          ...state.account,
          ...action.payload.account,
        },
        setup: {
          ...state.setup,
          ...(action.payload.workspace || action.payload.setup),
        },
        channelId: action.payload.channelId ?? state.channelId,
        updatedChannelId: action.payload.channelId ?? state.channelId,
        
        agentName: action.payload.agentName || state.agentName,
        agentId: action.payload.agentId || state.agentId,
        agentLanguage: action.payload.agentLanguage || state.agentLanguage,

        greeting: action.payload.greeting || state.greeting,
        updatedGreeting: action.payload.greeting || state.updatedGreeting,

        voices: action.payload.voices || state.voices,
        voice: action.payload.voice || state.voice,
        updatedVoice: action.payload.voice || action.payload.voices[0]?.id,
        isEnable: action.payload.isEnable !== undefined ? action.payload.isEnable : state.isEnable,

        isNew: action.payload.isNew !== undefined ? action.payload.isNew : state.isNew,

        systemFeatureFlags: action.payload.systemFeatureFlags || state.systemFeatureFlags,
      };

    case SET_TOKEN:
      return {
        ...state,
        token: action.payload.token,
        isValidToken: action.payload.isValidToken,
      };
    case SET_EXTERNAL_OVERLAY:
      return {
        ...state,
        externalOverlay: action.payload.externalOverlay,
      };
    case SET_IDS:
      return {
        ...state,
        organizationId: action.payload.organizationId,
        accountId: action.payload.accountId,
        setupId: action.payload.setupId,
      };
    case SET_SYSTEM_FEATURE_FLAGS:
      return {
        ...state,
        systemFeatureFlags: action.payload,
      };

    case UPDATE_DESTINATIONS:
      return {
        ...state,
        destinations: [...action.payload],
      };
    case UPDATE_SETUP_STATUS:
      return {
        ...state,
        isEnable: action.payload,
      };

    case UPDATE_VOICE: {
      console.log("UPDATE_VOICE", action.payload);
      return {
        ...state,
        updatedVoice: action.payload.updatedVoice,
        agentLanguage: action.payload.agentLanguage,
      };
    }

    case INIT_GREETING_FOR_NEW_SETUP:
      return {
        ...state,
        greeting: action.payload.greeting,
        updatedGreeting: action.payload.greeting,
      };
    case UPDATE_GREETING: {
      return {
        ...state,
        updatedGreeting: action.payload,
      };
    }

    case UPDATE_GREETING_ERROR: {
      return {
        ...state,
        greetingError: action.payload,
      };
    }

    case RESET_CHANNEL_ID: {
      return {
        ...state,
        channelId: null,
        updatedChannelId: null,
        channelIdError: null,
      };
    }

    case UPDATE_CHANNEL_ID: {
      return {
        ...state,
        updatedChannelId: action.payload,
        channelIdError: null,
      };
    }

    case UPDATE_CHANNEL_ID_ERROR: {
      return {
        ...state,
        channelIdError: action.payload,
      };
    }

    case SET_VOICES: {
      return {
        ...state,
        voices: action.payload,
      };
    }

    case SET_SAVE_ERROR: {
      return {
        ...state,
        saveError: action.payload,
      };
    }

    case "CANCEL": {
      return {
        ...state,
        updatedVoice: state.voice,
        updatedGreeting: state.greeting,
      };
    }
    case "SAVED": {
      return {
        ...state,
        greeting: state.updatedGreeting,
        voice: state.updatedVoice,
      };
    }

    default:
      return state;
  }
};

export default infoReducer;
